/** Helper method to convert the properties of the source object from PascalCase to camelCase */
export const toCamelCase = (source: object) => {
  const result = {};

  Object.keys(source).forEach((key) => {
    const value = source[key];

    const replacementKey = `${key.charAt(0).toLowerCase()}${key.substring(1)}`;
    result[replacementKey] = typeof value === 'object' ? toCamelCase(value) : value;
  });

  return result;
};

export const pascalToCamelCaseDeserializer = (parentKey: string, value: any) => {
  if (!(value && typeof value === 'object')) return value;

  const result = {};

  Object.keys(value).forEach((key) => {
    const replacementKey = `${key.charAt(0).toLowerCase()}${key.substring(1)}`;
    result[replacementKey] = value[key];
  });

  return result;
};
